
import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'date-selector-modal',
  templateUrl: './date-selector-modal.component.html',
  standalone: true,
  imports: [
    AfTranslateDirective,
    FormsModule,
    CalendarModule
  ]
})
export class DateSelectorModalComponent {
  configuration: any = this.dialogConfig.data;
  tomorrow : any = moment().add(1,'days');
  dateSelector: any = {
    preSelectItem: typeof this.configuration.selectedDate === 'string'?new Date(this.configuration.selectedDate):this.configuration.selectedDate,
    minDate: new Date(this.tomorrow),
  }
  constructor(private dialogRef: DynamicDialogRef<DateSelectorModalComponent>,
    private dialogConfig: DynamicDialogConfig) { }


  changeDatePicker(newValue:any){

  }

  handleAccept() {
    this.dialogRef.close({
      result: 'ok',
      selectedDate: this.dateSelector.preSelectItem
    });
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  }
}
